<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>

::-webkit-scrollbar {
  width: 3px;
  height: 5px;
  /* background-image: linear-gradient(135deg, #1DE9B6 0%, rgba(8, 196, 219, 0.5) 72%, rgba(0, 182, 234, 0.3) 100%); */
}
::-webkit-scrollbar-track {
  border-radius: 0;
}
::-webkit-scrollbar-thumb {
  border-radius: 0;
  background-image: linear-gradient(90deg, 
		#7068ee 0%, 
        #2f61ef 100%);
  transition: all .2s;
  border-radius: 5px;
}
::-webkit-scrollbar-thumb:hover {
  background-color: rgba(95, 95, 95, 0.7);
}
body{ 
    padding: 0;
    margin: 0
}
p,
ul,
li {
  padding: 0;
  margin: 0;
}
li {
  list-style: none;
}
a {
  text-decoration: none;
  color: black;
}
.clearfix::after {
  content: "";
  display: block;
  clear: both;
  visibility: hidden;
}
.MainContent{
    position: absolute;
    top: 60px;
    left:80px;
    right: 0;
    bottom: 0;
    background-color: rgb(235, 235, 235);
    padding: 20px;
    box-sizing: border-box;
    overflow: auto;
}
</style>



// WEBPACK FOOTER //
// src/App.vue